<template>
	<div
		class="user-registration-full-screen-layout"
		:class="{ 'show-page': !isUserRegistrationLoading, 'push-down': isSlideUpAnimation && !isStartMoveAnimation }"
	>
		<div class="layout-content">
			<slot />
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'UserRegistrationFullScreenLayout',
	props: {
		isSlideUpAnimation: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters(['isUserRegistrationLoading']),
	},
	mounted() {
		this.isStartMoveAnimation = true;
		setTimeout(
			() => {
				this.setIsUserRegistrationLoading(false);
			},
			this.isSlideUpAnimation ? 500 : 0
		);
	},
	methods: {
		...mapActions(['setIsUserRegistrationLoading']),
	},
	data: () => ({
		isStartMoveAnimation: false,
	}),
};
</script>

<style scoped lang="scss">
.user-registration-full-screen-layout {
	height: 100vh;
	overflow: auto;
	background-color: #f5f8fe;

	&:not(.show-page) {
		opacity: 0;
		transition: 0.5s;
	}
	&.show-page {
		opacity: 1;
		transition: 0.5s;
	}

	&.push-down .layout-content {
		transform: translateY(100vh);
	}
	&:not(.push-down) .layout-content {
		transform: translateY(0);
		transition: all 1.3s ease-out;
		transition-timing-function: cubic-bezier(0.42, 1.01, 0.42, 1.01);
	}

	.layout-content {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		min-height: 100vh;
		padding: 20px;

		::v-deep {
			.page-title {
				margin: 0 0 40px 0;
				text-align: center;
				font-size: 35px;
				font-weight: 700;
			}

			.form-section {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				max-width: 500px;

				.v-input {
					width: 500px;
				}

				.company-size {
					.v-chip-group .v-chip {
						margin: 4px 6px 4px 0;
						padding: 0 8px;
						font-size: 12px;
						background-color: #ffffff;
						border: 1px solid #dfe4ef;
					}
				}
			}

			button {
				width: 220px;
				height: 46px;
				margin: 50px 0 0 0;
				font-size: 14px !important;
				text-transform: none !important;
			}
		}
	}

	// Extra Small devices (landscape phones, 576px and up)
	@media (max-width: 575px) {
		.layout-content {
			::v-deep {
				.form-section {
					width: 100%;

					.signup-text-field,
					.signup-select-field,
					.v-input {
						width: 100%;
					}

					.v-slide-group__content {
						width: 100%;
						flex-wrap: wrap;
					}
				}
			}
		}
	}
}
</style>
